import React, { Component } from "react";
import Popup from "reactjs-popup";
import axios from 'axios';
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
// import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
// import ReactLoading from 'react-loading';

class CreateHousehold extends Component {

  constructor(props) {
    super(props);


    this.state = {
      GroupCode: '',
      GroupName: '',
      StartDate: this.formatDate(new Date()),
    }
  }

  componentDidMount() {

  }

  onOpen() {
  }

  saveNewEntry(cb) {
    if (this.validate()) {
      this.setState({ refreshText: 'Loading...' })
      var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

      var payload = {
        company: this.props.user.company,
        GroupCode: this.state.GroupCode,
        GroupName: this.state.GroupName,
        StartDate: this.state.StartDate
      };

      axios.post('api/groupMembershipNewEntry', payload, { headers }).then(response => {
        if (response.data.code === 200){
          cb(true)
          this.setState({ refreshText: '' })
        }
        else if (response.data.code === 301){
          alert('Entry already exists for this entity')
          this.setState({ refreshText: '' })
          cb(false)
        }
        else {
            alert('Error saving group')
            this.setState({ refreshText: '' })
            cb(false)
        }

      })
        .catch(err => {
          console.error(err);
          this.setState({ refreshText: '' })
          cb(false)
        })
    }
  }

  isValidDateString(str) {
  const date = new Date(str);
  return !isNaN(date.getTime());
}

  validate() {
    const regex = /^[a-zA-Z0-9]+$/;

      if (!this.state.GroupCode || !this.state.GroupName || !this.state.StartDate) {
        alert('All fields are required')
        return false
      }
      if (!this.isValidDateString(this.state.StartDate)){
        alert('Start Date is not valid')
        return false
      }
      if(!regex.test(this.state.GroupCode)){
        alert("Group may only contain alphanumeric characters")
        return false
      }

    return true
  }

  clearState = () => {
    this.setState({
      GroupCode: '',
      GroupName: '',
      StartDate: new Date()
    });
  }


  formatDate(d) {

    const day = String(d.getUTCDate()).padStart(2, '0');
    const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = d.getUTCFullYear();

    return `${year}-${month}-${day}`;

  }


  render() {

    return (
      <div className='billingPopup'>
        <Popup closeOnDocumentClick={false} trigger={this.props.button} onOpen={() => { this.onOpen(); }} onClose={() => { this.clearState(); this.props.refresh(); }} overlayStyle={{ zIndex: 5 }} modal >
          {close => (
            <div className="modal">
              <Button className="close" icon="close" onClick={(e) => { close(); }} />
              <div className="header" align="left">
                {'Create New'}
              </div>
              <div className="content">
                {
                  <>
                      <table style={{ paddingBottom: '10px' }}>
                        <tbody>
                            <tr key={0}>
                              <td style={{ width: '150px' }}>Group Code:</td>
                              <td><Input type="text" onChange={(e) => { this.setState({GroupCode: e.target.value}) }} value={this.state.GroupCode}/></td>
                            </tr>
                            <tr key={1}>
                              <td style={{ width: '150px' }}>Group Name:</td>
                              <td><Input type="text" onChange={(e) => { this.setState({GroupName: e.target.value}) }} value={this.state.GroupName} /></td>
                            </tr>
                          <tr key={2}>
                            <td style={{ width: '150px' }}>Start Date:</td>
                            <td><Input type="date" onChange={(e) => { this.setState({StartDate: e.target.value}) }} value={this.state.StartDate} defaultValue={this.formatDate(new Date())}/></td>
                          </tr>
                        </tbody>
                      </table>
                  </>
                }
              </div>
              <div className="actions">
                <Button
                  className="button"
                  onClick={() => { close(); }}>
                  Cancel
                </Button>
                <Button
                  className="upload"
                  onClick={() => { this.saveNewEntry((cb) => {if (cb === true) close();}) }}>
                  {'Save'}
                </Button>
              </div>
            </div>
          )}
        </Popup>
      </div>
    );
  };
}

export default CreateHousehold;